import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Cookies from 'js-cookie';
import { t } from '../../i18n/translate.js';
import '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import PasswordInput from '../../components/Input/PasswordInput.js';
import Icon from '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../services/ipcWeb/ipcService.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import styles from './ArmStateButton.module.scss.js';

var ArmStateButton = function (_a) {
    var _b;
    var pinCode = _a.pinCode, setPinCode = _a.setPinCode, isPolling = _a.isPolling, armStateStatus = _a.armStateStatus, pinCodeLength = _a.pinCodeLength, hasSmsOrEth = _a.hasSmsOrEth;
    var operatorId = Cookies.get('operatorId');
    var logo = {
        ARMED_HOME: {
            icon: 'icon-arm-stay',
            bgColor: 'armed-stay',
        },
        ARMED_AWAY: {
            icon: 'icon-arm-away',
            bgColor: 'armed-away',
        },
        DISARMED: { icon: 'icon-disarmed', bgColor: 'disarmed' },
    };
    var disabled = Boolean(operatorId || !hasSmsOrEth);
    var _c = (_b = logo[armStateStatus]) !== null && _b !== void 0 ? _b : logo.ARMED_HOME, bgColor = _c.bgColor, icon = _c.icon;
    var evalPin = function (value) {
        if (/^[0-9]+$/.test(value) || !value) {
            setPinCode(value);
        }
    };
    var getInfoText = function () {
        if (operatorId) {
            return t('MPLIB_OPERATOR_NOT_ALLOWED_WHEN_IMPERSONATING_MESSAGE');
        }
        return t('MPLIB_NO_SMS_OR_NO_ETHERNET');
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.armButtonWrapper },
            React.createElement("button", { type: "submit", className: classNames(styles.button, isPolling && styles.isLoading, styles[bgColor]), disabled: disabled },
                React.createElement(Icon, { icon: icon, className: styles.armIcon })),
            isPolling && (React.createElement(LoadingSpinner, { isLoading: true, size: "large", centered: true, color: bgColor, className: styles.loadingSpinner })),
            disabled && getInfoText()),
        React.createElement(PasswordInput, { onChange: function (v) { return evalPin(v); }, disabled: disabled, value: pinCode, maxLength: pinCodeLength, placeholder: t('MPLIB_ENTER_CODE_PLACEHOLDER'), className: styles.input, autoComplete: "off", dataTestId: "pinInput" })));
};
ArmStateButton.propTypes = {
    pinCode: PropTypes.string.isRequired,
    setPinCode: PropTypes.func.isRequired,
    isPolling: PropTypes.bool.isRequired,
};

export { ArmStateButton as default };
